import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-boolean-input',
  templateUrl: './boolean-input.component.html',
  styleUrls: ['./boolean-input.component.scss'],
})
export class BooleanInputComponent {
  @Input() checkedVariable = false;
  @Input() label: string = this.translateService.instant(
    'reports.only-work-time'
  );
  @Output() checkedVariableChange = new EventEmitter<boolean>();

  constructor(private translateService: TranslateService) {}

  onCheckedVariableChange(event) {
    this.checkedVariableChange.emit(event.target.checked);
  }
}
